// extracted by mini-css-extract-plugin
export var accordion = "_dc-0";
export var chevron = "_dc-3";
export var closed = "_dc-2";
export var content = "_dc-4";
export var open = "_dc-1";
export var rotate = "_dc-5";